module.exports = __webpack_public_path__ + "img/MunMunGames_Simple.b577f375.png";